import React from "react";
import { usePagination } from "react-instantsearch";

const Pagination = () => {
  const { pages, refine, currentRefinement, isFirstPage, isLastPage } =
    usePagination();

  return (
    <div className="pagination flex flex-wrap items-center justify-center gap-3 mt-8 px-4">
      {/* Previous Button */}
      <button
        className={`group flex items-center justify-center w-12 h-12 rounded-xl font-semibold transition-all duration-300 transform ${
          isFirstPage
            ? "bg-gray-100 text-gray-400 cursor-not-allowed shadow-sm"
            : "bg-white border-2 border-red-100 hover:border-red-300 hover:bg-red-50 text-red-600 shadow-lg hover:shadow-xl hover:scale-105 active:scale-95"
        }`}
        disabled={isFirstPage}
        onClick={() => refine(currentRefinement - 1)}
        aria-label="Previous Page"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2.5}
          stroke="currentColor"
          className={`w-5 h-5 transition-transform duration-300 ${
            !isFirstPage ? "group-hover:-translate-x-0.5" : ""
          }`}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          />
        </svg>
      </button>

      {/* Page Numbers */}
      {pages.map((page) => (
        <button
          key={page}
          className={`w-12 h-12 rounded-xl font-bold flex items-center justify-center transition-all duration-300 transform text-sm ${
            page === currentRefinement
              ? "bg-gradient-to-br from-red-500 to-red-600 text-white border-2 border-red-600 shadow-lg scale-110 shadow-red-200"
              : "bg-white border-2 border-red-100 hover:border-red-300 hover:bg-red-50 text-red-600 shadow-lg hover:shadow-xl hover:scale-105 active:scale-95"
          }`}
          onClick={() => refine(page)}
          aria-label={`Page ${page + 1}`}
        >
          {page + 1}
        </button>
      ))}

      {/* Next Button */}
      <button
        className={`group flex items-center justify-center w-12 h-12 rounded-xl font-semibold transition-all duration-300 transform ${
          isLastPage
            ? "bg-gray-100 text-gray-400 cursor-not-allowed shadow-sm"
            : "bg-white border-2 border-red-100 hover:border-red-300 hover:bg-red-50 text-red-600 shadow-lg hover:shadow-xl hover:scale-105 active:scale-95"
        }`}
        disabled={isLastPage}
        onClick={() => refine(currentRefinement + 1)}
        aria-label="Next Page"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2.5}
          stroke="currentColor"
          className={`w-5 h-5 transition-transform duration-300 ${
            !isLastPage ? "group-hover:translate-x-0.5" : ""
          }`}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.25 4.5l7.5 7.5-7.5 7.5"
          />
        </svg>
      </button>
    </div>
  );
};

export default Pagination;
